<template lang="pug">

full-width-page
  v-container(fluid)
    v-row(justify="center" align="center")
      v-col(cols="12" style="max-width:600px")
        //- v-alert.mb-3(:value="showActivated" type="success" color="success" border="bottom") {{$t('page.register:input.account.activated')}}
        v-alert.mb-3(:value="error.show" type="error" color="error") {{error.message}}
        v-card.mt-6.mb-3(outlined)
          v-card-text.text--primary
            h1.title.text-center {{$t('page.register:heading')}}
            validation-observer(v-slot="{ handleSubmit, invalid }")
              v-form(@submit.prevent="handleSubmit(onSubmit)" @keyup.native.enter="handleSubmit(onSubmit)")
                validation-provider(v-slot="{errors, touched}" rules="required|min:4|max:50" :name="$t('page.register:input.username')" slim)
                  v-text-field.mb-3(v-model="username" :label="$t('page.register:input.username')" required outlined hide-details="auto" :error-messages="touched ? errors : []")
                validation-provider(v-slot="{errors, touched}" rules="required|email" :name="$t('page.register:input.email')" slim)
                  v-text-field.mb-3(v-model="email" :label="$t('page.register:input.email')" required outlined hide-details="auto" :error-messages="touched ? errors : []")
                validation-provider(v-slot="{errors, touched}" rules="required|min:6" :name="$t('page.register:input.password')" slim)
                  v-text-field.mb-3(v-model="password" :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" :label="$t('page.register:input.password')" required outlined hide-details="auto" :error-messages="touched ? errors : []")
                .caption.my-3.text-center
                  i18n(path="page.register:register.disclaimer_{url}")
                    nuxt-link(to="/privacy-en-voorwaarden" target="_blank" slot="url") {{$t('page.register:privacy.policy.link')}}
                v-btn(type="submit" block color="accent" depressed :disabled="invalid") {{$t('page.register:submit.button')}}

</template>

<script>
import gql from 'graphql-tag';
import FullWidthPage from '@/components/pages/full-width-page.vue';

const registerMutation = gql`
	mutation (
		$username: String!
		$password: String!
		$email: String!
		$redirect: String
	) {
		signup(
			userData: {
				email: $email
				password: $password
				username: $username
				redirect: $redirect
			}
		)
	}
`;

export default {
	name: 'Register',
	components: {
		FullWidthPage
	},
	nuxtI18n: {
		paths: {
			'nl-NL': '/aanmelden',
			'de-DE': '/anmelden',
			'nl-BE': '/aanmelden'
		}
	},
	layout: 'empty',
	asyncData({ app, store, redirect }) {
		if (store.state.user.id) {
			redirect('/');
		}

		app.ads({});
		app.meta({
			title: app.i18n.t('page.register:input.heading')
		});
		app.breadcrumbs({});
	},
	data() {
		return {
			email: '',
			username: '',
			password: '',
			showPassword: false,
			error: {
				show: false,
				message: null
			}
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	methods: {
		onSubmit() {
			this.error = {
				show: false
			};
			this.$graphClient
				.mutate({
					mutation: registerMutation,
					variables: {
						email: this.email,
						password: this.password,
						username: this.username,
						redirect: this.$route.query.redirect
					}
				})
				.then(({ data, errors }) => {
					if (errors) {
						if (errors.length > 0 && errors[0].message === 'marked.as.spam') {
							return (this.error = {
								show: true,
								message: this.$t(`page.register:error.${errors[0].message}`)
							});
						}

						this.error = {
							show: true,
							message: this.$t(`page.register:error.${errors[0].message}`)
						};
					}
					if (data.signup) {
						this.$router.push(this.localePath({ name: 'registerconfirm' }));
					}
				});
		}
	}
};
</script>
